function remapReviews(reviewsResponse) {
    return reviewsResponse.data.map(review => {
        review.answer['question_text'] = review.answer.question.title;
        return review;
    });
}

export { remapReviews };